import { API_BASE_URL } from '../constants/main';
import { loadUserFromStorage } from '../utils/authStorage';
import type {
  PortalUsagePlatform,
  PortalUsageProductContext,
  PortalUsageSurface,
} from '../types/portalUsage';

export type PortalUsageCollectPayload = {
  routePath: string;
  tab: string | null;
  platform: PortalUsagePlatform;
  surface: PortalUsageSurface;
  productContext: PortalUsageProductContext;
};

function isClientCollectionEnabled(): boolean {
  const v = process.env.REACT_APP_PORTAL_USAGE_ENABLED;
  if (v === undefined || v === '') return true;
  return v === 'true' || v === '1';
}

function isGodModeOnlyClient(): boolean {
  return (
    process.env.REACT_APP_PORTAL_USAGE_GOD_MODE_ONLY === 'true' ||
    process.env.REACT_APP_PORTAL_USAGE_GOD_MODE_ONLY === '1'
  );
}

let lastDedupeKey = '';
let lastDedupeAt = 0;
const DEDUPE_MS = 2500;

export function shouldSendPortalUsageEvent(dedupeKey: string): boolean {
  const now = Date.now();
  if (dedupeKey === lastDedupeKey && now - lastDedupeAt < DEDUPE_MS) {
    return false;
  }
  lastDedupeKey = dedupeKey;
  lastDedupeAt = now;
  return true;
}

/**
 * Non-blocking POST to /admin/portal-usage/collect (keepalive fetch).
 * Increments server-side daily rollup counters only — no per-user payload.
 */
export function collectPortalUsage(payload: PortalUsageCollectPayload): void {
  if (!isClientCollectionEnabled()) return;

  const stored = loadUserFromStorage();
  const token = stored?.token;
  if (!token) return;

  if (isGodModeOnlyClient() && !stored?.user?.isGodModeUser) {
    return;
  }

  const url = `${API_BASE_URL}/admin/portal-usage/collect`;
  const body = JSON.stringify(payload);

  try {
    void fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // ignore
  }
}
